import axios from "axios";
import useAppSelector from "hooks/useAppSelector";
import { useMutation } from "@tanstack/react-query";
import { getReportUrl } from "config/configUtils";
import { getFormattedError } from "utils/apiConfigurations";

type Props = {
  bookingIds: string[];
};

export const usePostCancelExcursions = () => {
  const sessionId = useAppSelector((state) => state.authentication.sessionId);

  const { mutateAsync, isPending, error, isSuccess } = useMutation({
    mutationFn: async ({ bookingIds }: Props) => {
      const URL = `${getReportUrl()}api/excursions/cancel`;

      const result = await axios.post(
        URL,
        { bookingIds: bookingIds },
        {
          headers: {
            SessionId: sessionId,
          },
        }
      );

      return result;
    },
  });

  const postCancelExcursions = async (bookingIds: string[]) => {
    await mutateAsync({ bookingIds });
  };

  return {
    cancelExcursions: postCancelExcursions,
    cancelExcursionsLoading: isPending,
    cancelExcursionsError: getFormattedError(error),
    cancelExcursionsIsSuccess: isSuccess,
  };
};
